<div class="multisearch">
  
  <div class="multisearch-grid">

    <!-- Dropdown for selecting Filter -->
    <nz-select nzShowSearch  [ngModel]="0">
      <nz-option *ngFor="let s of searchables;let i = index;" [nzLabel]="s" [nzValue]="i"></nz-option>
    </nz-select>

    <!-- Input filed (resets and changes based on dropdown selection) -->
    <input type="text" nz-input placeholder="Start typing"
           [(ngModel)]="searchTerm" (ngModelChange)="modelChanged($event)"/>

    <!-- Button Add row (FIRST ROW WILL HAVE THIS) -->
    <button nz-button nzType="dashed" (click)="addRow()">
      <i nz-icon nzType="plus"  nzTheme="outline"></i>
    </button>

  </div>

  <!-- DEMO REPEAT OF ROWS -- Can Ignore -->
  <div class="multisearch-grid" *ngFor="let row of rows; let i = index;">
    <nz-select nzShowSearch  [ngModel]="0">
      <nz-option *ngFor="let s of searchables;let i = index;" [nzLabel]="s" [nzValue]="i"></nz-option>
    </nz-select>
    <!-- Input -->
    <nz-select nzShowSearch  style="width: auto" nzAllowClear nzPlaceHolder="Choose">
      <nz-option nzValue="Sample Value 1" nzLabel="Sample Value X"></nz-option>
      <nz-option nzValue="Sample Value 2" nzLabel="Sample Value Y"></nz-option>
    </nz-select>
    <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove this row?" nzOkText="Remove" nzCancelText="Cancel"
            (nzOnConfirm)="removeRow()">
      <i nz-icon nzType="delete" nzTheme="outline"></i>
    </button>
  </div>
  
  <!-- Button -->
  <div class="multisearch-grid" *ngIf="searchHasData">
    <!-- Button Add row (FIRST ROW WILL HAVE THIS) -->
    <button nz-button nzType="primary">
      Search
    </button>
    <div class="msg-clear"><a class="col-grey-dark" (click)="clearAll()">Clear all</a></div>
    <div></div>
  </div>  

  <!-- Add New Row (Always show ?) -- >
  <div class="multisearch-add-row multisearch-grid">
      <div><span class="p-l-10">Add new filter</span></div>
      <div>&nbsp;</div>
      <button nz-button nzType="dashed" (click)="addRow()">
          <i nz-icon nzType="plus"  nzTheme="outline"></i>
      </button>
  </div>
  <!-- -->

</div>
